import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { useAuth } from "../../context/AuthContext";
import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import { Shield, UserPlus, Plus, TrendingUp, ScrollText, Receipt, EyeOff } from "lucide-react";

const adminLinks = [
  { to: "/admin/add-transaction", label: "Add Transaction", icon: Plus },
  { to: "/admin/members", label: "Manage Members", icon: UserPlus },
  { to: "/admin/portfolio-values", label: "Portfolio Values", icon: TrendingUp },
  { to: "/admin/profit-loss", label: "P&L Statement", icon: Receipt },
  { to: "/admin/page-access", label: "Page Access", icon: EyeOff },
  { to: "/admin/audit-log", label: "Audit Log", icon: ScrollText },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin")
    return <Navigate to="/" replace />;

  return (
    <AppShell>
      <div className="inline-flex items-center gap-2 text-[10px] text-amber-300/90 uppercase tracking-[0.22em] font-mono">
        <span className="pulse-dot" style={{ width: 6, height: 6, background: "#fbbf24", boxShadow: "0 0 12px rgba(251,191,36,0.7)" }} />
        <Shield size={11} /> Admin Panel
      </div>
      <h1 className="text-2xl md:text-4xl font-display text-white mt-1 tracking-tight">
        Manage Portfolio
      </h1>
      <p className="text-sm text-slate-400 mt-1 font-mono">
        Record transactions, manage member access, and update portfolio values.
      </p>

      <div className="mt-5 flex gap-2 overflow-x-auto no-scrollbar">
        {adminLinks.map((l) => {
          const active = location.pathname === l.to;
          return (
            <NavLink
              key={l.to}
              to={l.to}
              className={`flex items-center gap-2 px-3 py-2 rounded-md text-xs font-medium border whitespace-nowrap transition-colors ${
                active
                  ? "bg-amber-500 text-slate-950 border-amber-500"
                  : "bg-slate-900 text-slate-400 border-slate-800 hover:text-white"
              }`}
            >
              <l.icon size={14} />
              {l.label}
            </NavLink>
          );
        })}
      </div>

      <div className="mt-5">
        <Outlet />
      </div>
    </AppShell>
  );
}
